<template>
  <div id='zhlogin'>
      <NavTop title="账号登陆" />
      <div class='loginform'>
          <div class='title-con'><span class="title">账号密码登陆</span></div>
          <div class='login-input'>
             <div class='login-input-icon'><Icon src='user' class='login-input-svg'/></div><div class='login-input-content'> <input type='text' v-model='username' placeholder="请输入手机号码/会员名"/></div>
          </div>
          <div class='login-input'>
             <div class='login-input-icon'><Icon src='password' class='login-input-svg'/></div><div class='login-input-content'> <input type='password' placeholder="请输入登陆密码" v-model='password' /></div>
          </div>
          <div class='login-btn-con'>
              <button class='login-btn' block @click='doLogin()'>登  陆</button>
          </div>     
      </div>    
      <div class='bottomwords'>
        <div class="brow article">已阅读并同意<span class="blink" @click="goArticle(2)">《蓉畅生物科技服务协议》</span>和<span class="blink" @click="goArticle(2)">《隐私协议》</span></div>
        <div class="brow" @click="goBeian">闽ICP备20023082号-1</div>
      </div>
  </div>
</template>
<script>
import Icon from '@/components/icon'
import NavTop from '@/components/navtop'
export default {
   name: 'zhlogin',
   data() {
        return {
          username:'',
          password:''
        };
   }, 
   methods: {
    goBeian(){
         window.location.href="https://beian.miit.gov.cn/"
     },
      doLogin(){
          if(this.username=='') {
              this.$toast("用户名不能为空")
              return false
          }
          if(this.password=='') {
              this.$toast("密码不能为空")
              return false
          }
          this.$store.dispatch("doLogin",{username:this.username,password:this.password}).then((data)=>{
              if(!data.result.success){
                  this.$toast(data.result.info);return false;
              }
              this.$go('/index')
          })
      },
      goArticle(type){
        this.$go({name:'gongkai',params:{type:type}})    
      }
   },
   components: {
        Icon,NavTop
   }
}
</script>
<style scoped>
#zhlogin{background-color:#fff;min-height: 100vh;z-index:999;padding: 0 0.5rem;overflow:hidden;position: relative;margin:0 auto;max-width:640px;color:#ffffff;}
.logo{margin-top:3.5rem;}
.logoimg{width:4rem;height:4rem;}
.loginform{margin-top: 4rem;}
.title-con{padding: 0.3rem;text-align: left!important;}
.title{font-size:0.5rem;padding: 0.2rem;color:#333;}
.subtitle{font-size:0.3rem;padding: 0 0.1rem 0.1rem;}
.login-btn-con{margin-top: 0.5rem;}
.login-btn{width: 100%;height: 1.067rem;color: #000;text-align: center;line-height: 1.067rem;font-size: 0.36rem;border-radius: 0.2rem;background-image: linear-gradient(to right,#cccccc,#dddddd);}
.login-input{background-color: #eeeeee;height:1.2rem;margin-top: 0.2rem;border-radius: 0.2rem;display:flex;align-items: center;}
.login-input-icon{width:1.25rem;text-align: center;}
.login-input-svg{width:0.5rem;height:0.5rem;}
.login-input-content{flex:3;}
.login-input-content input{outline: none;border: none;background-color: #eeeeee;height:1rem;line-height: 1rem;width:100%;font-size:0.4rem;border-radius: 0.2rem;color:#000000;}
.forget_password{margin-top: 0.4rem;color:#7AB5FB;font-size:0.3rem;letter-spacing: 1px;}
.bottomwords{text-align: center;font-size:0.30rem;color:#000000;width:100%;margin-top:2rem;}
.brow{padding: 0.1rem;cursor: pointer;}
.blink{font-weight: 600;}
</style>